import React from "react";
import { Button, Icon, Toast } from "antd-mobile";
import { post } from "../../../utils/request";
import { href } from "../../../utils/util";

import "./index.less";

var timer;
class AttestationStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            second: 5,
            secondType: false,
        };
    }

    componentWillReceiveProps(prevProps) {
        clearInterval(timer);
        if (prevProps.status === "loading") {
            this.timeFN();
        }
    }

    timeFN = () => {
        let _this = this;
        clearInterval(timer);
        this.setState(
            {
                second: 5,
            },
            () => {
                let { second } = this.state;
                timer = setInterval(() => {
                    if (second < 0) {
                        clearInterval(timer);
                        this.props.onQuit("error"); //临时-============================
                    } else {
                        _this.setState({
                            second: second--,
                        });
                    }
                }, 1000);
            }
        );
    };

    render() {
        let { iconType, second } = this.state;
        return (
            <div className="AttestationStatusBox">
                {this.props.status ? (
                    <div>
                        {this.props.status === "error" ? (
                            <div className="error">
                                <div>
                                    <Icon
                                        type="cross-circle-o"
                                        size="lg"
                                    />
                                    <span>认证失败</span>
                                    {this.props.caType === "PERSONAL" ? (
                                        <p>请确保本人操作且正脸对框</p>
                                    ) : (
                                        ""
                                    )}
                                </div>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        // this.props.onRestart();
                                        this.props.onQuit("");
                                    }}
                                >
                                    重新认证
                                </Button>
                                {/* <Button onClick={()=>{
                                    if(localStorage.getItem('app_stoken')){
                                        window.location.href = `${window.location.origin}/#/ACGuide?app_stoken=${localStorage.getItem('app_stoken')}&thirdContractId=${localStorage.getItem('thirdContractId')}`
                                    }else{
                                        window.location.href = `${window.location.origin}/#/ACGuide`
                                    }
                                }}>退出验证</Button> */}
                            </div>
                        ) : (
                            ""
                        )}
                        {this.props.status === "success" ? (
                            <div className="success">
                                <div>
                                    <Icon
                                        type="check-circle"
                                        size="lg"
                                    />
                                    <span>申请成功</span>
                                    <p>
                                        您已成功申请专属数字证书，用于远程慧联电子合同签署！
                                    </p>
                                </div>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        window.location.href = "";
                                    }}
                                >
                                    前往签署
                                </Button>
                            </div>
                        ) : (
                            ""
                        )}
                        {this.props.status === "loading" ? (
                            <div className="loading">
                                <div>
                                    <i></i>
                                    <span>专属数字证书申请中</span>
                                    <p>
                                        请耐心等待 <span>{second}</span> 秒
                                    </p>
                                </div>
                                <Button
                                    type="primary"
                                    disabled
                                >
                                    前往签署
                                </Button>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    }
}

export default AttestationStatus;



// WEBPACK FOOTER //
// ./src/authCertificate/modules/attestationStatus/index.js